import { apiJson, apiUrl, getToken } from './http';

export type ProfileDto = {
  username?: string;
  email?: string;
  avatar_url?: string | null;
  subscription_type?: string;
  subscription_expiry?: string | null;
  created_at?: string | null;
  last_login?: string | null;
  max_channels?: number;
  max_movies?: number;
};

export async function fetchProfile(): Promise<ProfileDto> {
  return apiJson<ProfileDto>('/api/user/profile.php');
}

export async function updateProfile(payload: {
  username: string;
  email: string;
  current_password?: string;
  new_password?: string;
}): Promise<{ success: boolean; message?: string; user?: ProfileDto }> {
  return apiJson('/api/user/profile.php', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function uploadAvatar(file: File): Promise<{ success: boolean; avatar_url?: string; message?: string }> {
  const token = getToken();
  const fd = new FormData();
  fd.append('avatar', file);
  const headers: HeadersInit = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(apiUrl('/api/user/avatar.php'), {
    method: 'POST',
    headers,
    body: fd,
  });
  const text = await res.text();
  try {
    return JSON.parse(text) as { success: boolean; avatar_url?: string; message?: string };
  } catch {
    throw new Error(text.slice(0, 120));
  }
}

export async function deleteAvatar(): Promise<{ success: boolean; message?: string }> {
  return apiJson('/api/user/avatar.php', { method: 'DELETE' });
}
